// extracted by mini-css-extract-plugin
export default {"dropdownManage":"Courses_dropdownManage__4R9zr"};